@if (layout() === 'inline') {
    @if (message(); as statusMessage) {
        <span class="me-2" [class.text-success]="!statusMessage.isError" [class.text-danger]="statusMessage.isError">
            {{ statusMessage.text }}
        </span>
    }
    <button type="button" class="btn btn-primary" [disabled]="isSaving() || disabled()" (click)="saveRequested.emit()">
        {{ label() }}
    </button>
} @else {
    <button
        type="button"
        class="btn btn-primary w-100"
        [disabled]="isSaving() || disabled()"
        (click)="saveRequested.emit()"
    >
        {{ label() }}
    </button>
    @if (message(); as statusMessage) {
        <span
            class="mt-2 text-center d-block"
            [class.text-success]="!statusMessage.isError"
            [class.text-danger]="statusMessage.isError"
        >
            {{ statusMessage.text }}
        </span>
    }
}
